module.exports = __webpack_public_path__ + "media/customizations/breezehome/back-caf45007f3c41c17f8e149579fb49b69.jpg";